import React from 'react';
import { MarketIndex } from '../services/mcpClient';

interface MarketIndicesProps {
  indices: MarketIndex[];
  loading: boolean;
  error: string | null;
}

const MarketIndices: React.FC<MarketIndicesProps> = ({ indices, loading, error }) => {
  if (loading) {
    return (
      <div className="market-indices">
        <h3>📊 Market Indices</h3>
        <div className="loading">Loading market indices...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="market-indices">
        <h3>📊 Market Indices</h3>
        <div className="error">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="market-indices">
      <h3>📊 Market Indices</h3>
      <div className="indices-grid">
        {indices.map((index) => (
          <div key={index.symbol} className="index-card">
            <div className="index-header">
              <h4>{index.name}</h4>
              <span className="index-symbol">{index.symbol}</span>
            </div>
            <div className="index-price">
              {index.price !== null ? `$${index.price.toFixed(2)}` : 'N/A'}
            </div>
            <div className={`index-change ${(index.changePercent || 0) >= 0 ? 'positive' : 'negative'}`}>
              {index.change !== null && index.changePercent !== null ? (
                <>
                  {index.change >= 0 ? '+' : ''}{index.change.toFixed(2)} 
                  ({index.changePercent >= 0 ? '+' : ''}{index.changePercent.toFixed(2)}%)
                </>
              ) : 'N/A'}
            </div>
            <div className="index-details">
              <div className="detail-item">
                <span className="label">High:</span>
                <span className="value">
                  {index.dayHigh !== null ? `$${index.dayHigh.toFixed(2)}` : 'N/A'}
                </span>
              </div>
              <div className="detail-item">
                <span className="label">Low:</span>
                <span className="value">
                  {index.dayLow !== null ? `$${index.dayLow.toFixed(2)}` : 'N/A'}
                </span>
              </div>
              <div className="detail-item">
                <span className="label">Volume:</span>
                <span className="value">
                  {index.volume !== null ? index.volume.toLocaleString() : 'N/A'}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MarketIndices;

